import { isValidElement } from 'react';

function isClassComponent(component) {
  return typeof component === 'function' &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  !!component.prototype.isReactComponent;
}
function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('return React.createElement');
}
function isReactComponent(component) {
  return isClassComponent(component) || isFunctionComponent(component);
}

/**
 * Indicates if one or more translation placeholders are a React component or element.
 * @param placeholders - The translation string placeholders.
 * @returns - True if at least one placeholder is a React component or element; otherwise false.
 */
function containsComponentOrElement(placeholders) {
  return Object.keys(placeholders).some(key => isReactComponent(placeholders[key]) || /*#__PURE__*/isValidElement(placeholders[key]));
}

export { containsComponentOrElement as default };
